import { LogPersistenceInterface, LogLevel } from '../interfaces/LogPersistenceInterface';
import { IframeMessengerable } from '../IframeMessengerPlayerAbstract';
import { Deferred } from '../../Utility/Deferred';
import PlayerActions from '../enums/PlayerActions';

/**
 * Mixin to add LogPersistence to IframeMessengerable type
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function LogPersistable<TBase extends IframeMessengerable>(Base: TBase) {
    return class LogPersistable extends Base implements LogPersistenceInterface {
        /**
         * @throws {RangeError} - Thrown when invalid log level is given
         */
        setLogLevel(logLevel: LogLevel): PromiseLike<void> {
            const setLogAction: Record<LogLevel, PlayerActions> = {
                info: PlayerActions.SET_LOG_LEVEL_INFO,
                warn: PlayerActions.SET_LOG_LEVEL_WARN,
                error: PlayerActions.SET_LOG_LEVEL_ERROR,
                debug: PlayerActions.SET_LOG_LEVEL_DEBUG,
            };
            if (!setLogAction[logLevel]) {
                return Deferred.rejected(new RangeError('Invalid log level.'));
            } else {
                return this._performPlayerAction(setLogAction[logLevel]);
            }
        }

        enablePersistentLog(): Deferred<void> {
            return this._performPlayerAction(PlayerActions.ENABLE_PERSISTENT_FILE_LOG);
        }

        disablePersistentLog(): Deferred<void> {
            return this._performPlayerAction(PlayerActions.DISABLE_PERSISTENT_FILE_LOG);
        }
    };
}
